import 'dayjs/locale/en';
import 'dayjs/locale/vi';
import 'dayjs/locale/fr';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ar-sa';

import dayjs from 'dayjs';
import { useEffect } from 'react';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider as Provider } from '@mui/x-date-pickers/LocalizationProvider';

import { useTranslate } from './use-locales';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function LocalizationProvider({ children }: Props) {
  const { currentLang } = useTranslate();

  dayjs.locale(currentLang.adapterLocale);

  // Apply Arabic font when Arabic language is selected
  useEffect(() => {
    const htmlElement = document.documentElement;
    const bodyElement = document.body;

    if (currentLang.value === 'ar') {
      // Set lang attribute for Arabic
      htmlElement.setAttribute('lang', 'ar');
      bodyElement.setAttribute('lang', 'ar');

      // Add Arabic font class
      htmlElement.classList.add('arabic-font');
      bodyElement.classList.add('arabic-font');
    } else {
      // Remove Arabic attributes and classes for other languages
      htmlElement.removeAttribute('lang');
      bodyElement.removeAttribute('lang');
      htmlElement.classList.remove('arabic-font');
      bodyElement.classList.remove('arabic-font');

      // Set appropriate lang attribute for other languages
      htmlElement.setAttribute('lang', currentLang.value);
      bodyElement.setAttribute('lang', currentLang.value);
    }
  }, [currentLang.value]);

  return (
    <Provider dateAdapter={AdapterDayjs} adapterLocale={currentLang.adapterLocale}>
      {children}
    </Provider>
  );
}
